import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {ProgramService} from '@services/program/program.service';
import {FormBuilder, FormControl} from '@angular/forms';
import * as moment from 'moment';
import {Store} from '@ngrx/store';
import * as ProgramReducer from '@store/program/reducers';
import {AddProgram, UpdateProgram} from '@store/program/actions';
import {Program} from '@models/program';
import {ErrorResponse} from '@interfaces/responses/error-response';
import {ClassService} from '@services/class/class.service';
import {Class} from '@models/class';
import {Schedule} from '@models/schedule';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {MatDialog} from '@node_modules/@angular/material';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {TeacherService} from '@services/teacher/teacher.service';
import {User} from '@models/user';
import {StudentCreateComponent} from '@pages/layout/student/student-create/student-create.component';
import * as TeacherReducer from '@store/teacher/reducers';
import {ActionTypes, AddTeacher, SetTeachers} from '@store/teacher/actions';
import {TeacherState} from '@store/teacher/reducers';
import {ProgramScheduleComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule.component';
@Component({
  selector: 'app-program-create',
  templateUrl: './program-create.component.html',
  styleUrls: ['./program-create.component.scss']
})
export class ProgramCreateComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('create_program_wrapper') host: ElementRef;
  @ViewChild('program_name') program_name: ElementRef;
  @ViewChild('description') description: ElementRef;
  @ViewChild('time') time: ElementRef;
  @ViewChild('teacherId') teacherId;
  static source;
  static selectedDate;
  static dialogRef;
  static source_program_edit = 'program_edit';
  static source_class_edit = 'class_edit';
  static source_class = 'class';
  static sourceSchedule;
  static program: Program;
  static editedItem: {
    id: number,
    name: string,
    description: string,
    schedule: Schedule[],
    selectedSchedule: Schedule,
    teachers: User[],
    classes?: Class[],
    default_teacher?: User,
  };
  dropdownSettings = {
    singleSelection: false,
    // maxHeight: 0,
    text:"Select Teacher",
    position: 'top',
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    classes:"multi-select-teacher"
  };
  selectedTeachers = [];
  editableInputs = ['name', 'description'];
  initSelected:  {month: number, day: number};
  initDayName: string;
  repeat_time = 'none';
  repeatDefaultValue = 'week';
  setTimeStart: BehaviorSubject<{hours: string, minutes: string,  index: string}> = new BehaviorSubject(null);
  setTimeEnd: BehaviorSubject<{hours: string, minutes: string, index: string}> = new BehaviorSubject(null);
  moveMonthsCarousel: BehaviorSubject<string> = new BehaviorSubject(null);
  selectingTime: Subject<any> = new BehaviorSubject(null);
  repeatEnable = false;
  monthsSchedule: Subject<Object> = new BehaviorSubject(null);
  monthsNumber: Subject<any> = new BehaviorSubject(null);
  schedule = {};
  tmpSchedule = {};
  tmpName = '';
  tmpDescription = '';
  tmpMultipleSelectedTeacher = [];
  reorganizedScheduleByWeekName = {};
  insertingSchedule: Subject<any> = new BehaviorSubject<any>(this.schedule);
  sourceName;
  currentMonth = new Date().getMonth() + 1;
  currentYear = new Date().getFullYear();
  unique_schedule = true;
  selectedDays = [];
  confirmDeletePopup = false;
  errors = {};
  confirmDialog;
  dialogRefCreateModal;
  timeSlots = [];
  subscribes = [];
  confirmDeleteDialog;
  months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  toDays = [
    {
      name: 'Today',
      id: 'id'
    },
    {
      name: 'Tomorrow',
      id: 'id'
    }
  ];
  teachers: User[] = [];
  multiselectTeachers = [];
  constructor(
      private fb: FormBuilder,
      public dialog: MatDialog,
      private elRef: ElementRef,
      private renderer: Renderer2,
      private classService: ClassService,
      private programService: ProgramService,
      private teacherService: TeacherService,
      private teacherStore: Store<TeacherReducer.TeacherState>,
      private programStore: Store<ProgramReducer.ProgramState>
  ) {
    if (ProgramCreateComponent.program && ProgramCreateComponent.program.repeat) {
      this.repeatEnable = ProgramCreateComponent.program.repeat === 'week';
    }
    if (ProgramCreateComponent.editedItem && ProgramCreateComponent.editedItem.schedule && ProgramCreateComponent.editedItem.schedule[0]) {
      this.unique_schedule = !ProgramCreateComponent.editedItem.selectedSchedule.replaced_schedule;
      this.schedule = ProgramCreateComponent.sourceSchedule ? Object.assign({}, ProgramCreateComponent.sourceSchedule) : {};
      this.tmpSchedule = ProgramCreateComponent.sourceSchedule ? Object.assign({}, ProgramCreateComponent.sourceSchedule) : {};
      if (this.repeatEnable === true) {
        this.reorganizeScheduleByWeekDay();
      }
      this.timeSlots = [];
      const schedul = ProgramCreateComponent.editedItem.selectedSchedule as Schedule;
      this.initSelected = { month: +schedul.month, day: +schedul.day};
      if (this.repeatEnable === false) {
        this.currentMonth = +schedul.month;
        this.monthsNumber.next({month: this.currentMonth, year: this.currentYear});
      }
      // this.initDayName = schedul.dayName;
      const dayFromCurrentMonth = this.repeatEnable ? this.getDayfromDayWeek(schedul.dayName) : schedul.day;
      this.onSelectedDay({day: dayFromCurrentMonth, cntr: false, month: this.currentMonth, dayName: schedul.dayName, initDayName: true});
      this.onSaveTimeSlot();
    }
  }
  ngOnInit() {
    this.sourceName = ProgramCreateComponent.source;

    if (this.sourceName === 'class') {
      this.program_name.nativeElement.value = 'Class ' +  (ProgramCreateComponent.program.classes.length + 1) ;
    }
    // const bodyHeight = document.getElementsByTagName('body').item(0).clientHeight;
    // if (bodyHeight < 800) {
    //   this.renderer.setStyle(this.host.nativeElement, 'height', bodyHeight - 50 + 'px');
    // }
    // this.onAddTimeSlot();
    this.subscribes.push(this.teacherStore.subscribe(
        (val) => {
          if (val) {

            const teacherStore = <TeacherState>val.teacher;
            if (teacherStore) {
              if (teacherStore.lastAction === ActionTypes.ADD_TEACHER || teacherStore.lastAction === ActionTypes.SET_TEACHERS) {
                teacherStore.teachers.map( t => {
                  if (!this.teachers.some(i => i.id === t.id)) {
                    this.teachers.push(t);
                    this.multiselectTeachers.push({
                      id: t.id,
                      itemName: t.name
                    });
                  }
                });
              }
            }
          }
        }
    ));
    if (this.isForClass()) {
      if (this.sourceName === ProgramCreateComponent.source_class && ProgramCreateComponent.program) {
        const defaultTeacher = ProgramCreateComponent.program.default_teacher;
        if (defaultTeacher) {
          this.selectedTeachers.push({
            id: defaultTeacher.id,
            itemName: defaultTeacher.name
          });
        }
      }
      if (this.sourceName === ProgramCreateComponent.source_class_edit && ProgramCreateComponent.editedItem.teachers) {
        this.teachers.map( teach => this.multiselectTeachers.push({
          id: teach.id,
          itemName: teach.name
        }));
        ProgramCreateComponent.editedItem.teachers.map( t => {
          this.selectedTeachers.push({
            id: t.id,
            itemName: t.name
          });
          this.tmpMultipleSelectedTeacher.push({
            id: t.id,
            itemName: t.name
          });
        })
      }
    }
  }
  ngOnDestroy() {
    this.subscribes.map( subscr => subscr.unsubscribe());
  }
  ngAfterViewInit() {
    // if (this.schedule[this.currentMonth]) {
    //   this.monthsSchedule.next(this.schedule[this.currentMonth]);
    // }
    if (ProgramCreateComponent.editedItem) {
      this.program_name.nativeElement.value = ProgramCreateComponent.editedItem.name;
      this.description.nativeElement.value = ProgramCreateComponent.editedItem.description;
      // this.teacherId.value = ProgramCreateComponent.editedItem.teachers && ProgramCreateComponent.editedItem.teachers[0] ? ProgramCreateComponent.editedItem.teachers[0].id : null;
    }
    this.insertingSchedule.next(this.schedule);
    this.tmpSchedule = Object.assign({}, this.schedule);
    this.tmpName = this.program_name.nativeElement.value;
    this.tmpDescription = this.description.nativeElement.value;
    if (this.isPrgramEdit()) {
      this.teacherId.value = ProgramCreateComponent.editedItem.default_teacher ? ProgramCreateComponent.editedItem.default_teacher.id : null;
    }
    if (!this.teachers || this.teachers.length === 0) {
      this.getAllTeachers();
    }
  }
  onCreate(): void {
    if (this.checkErrors) {
      this.programService.create({
        program_name: this.program_name.nativeElement.value,
        program_description: this.description.nativeElement.value,
        schedule: this.changeDateFormaInSchedule(),
        repeat_time: this.repeatEnable === true ? 'week' : 'none',
        default_teacher_id: this.teacherId.value
      }).subscribe(
          (resp: {data: Program}) => {
            this.programStore.dispatch(new AddProgram(resp.data));
            if (ProgramCreateComponent.dialogRef) {
              ProgramCreateComponent.dialogRef.close();
            }
          },
          (err: ErrorResponse) => {
            Object.keys(err.error.errors).map(item => {
              this.errors[item] = err.error.errors[item];
            });
          }
      );
    }
  }
  onCreateClass() {
    if (this.checkErrors()) {
      const teachers = [];
      this.selectedTeachers.map( t => teachers.push(+t.id));
      this.classService.createClass({
        class_name: this.program_name.nativeElement.value,
        class_description: this.description.nativeElement.value,
        schedule: this.changeDateFormaInSchedule(),
        repeat_time: this.repeat_time == 'false' || this.repeat_time == 'none' ? 'none' : 'week',
        replaced_schedule: this.unique_schedule === false ? ProgramCreateComponent.editedItem.selectedSchedule ? ProgramCreateComponent.editedItem.selectedSchedule.id : null : null,
        teachers: teachers,
        program_id: ProgramCreateComponent.program.id
      }).subscribe(
          (resp: {data: {classc: Class, schedules: Schedule[]}}) => {
            ProgramCreateComponent.program.schedule = resp.data.schedules;
            ProgramCreateComponent.program.classes.push(resp.data.classc);
            ProgramScheduleComponent.classesByDates = {};
            this.programStore.dispatch(new UpdateProgram(ProgramCreateComponent.program));
            if (ProgramCreateComponent.dialogRef) {
              ProgramCreateComponent.dialogRef.close();
            }

          }
      );
    }
  }
  onEditProgram() {
    this.programService.edit({
      id: ProgramCreateComponent.editedItem.id,
      name: this.program_name.nativeElement.value,
      description: this.description.nativeElement.value,
      default_teacher_id: this.teacherId.value
    }).subscribe(
        (resp: {data: Program}) => {
          this.programStore.dispatch(new UpdateProgram(resp.data));
          if (ProgramCreateComponent.dialogRef) {
            ProgramCreateComponent.dialogRef.close();
          }
        }
    );
  }
  onEditClass() {
    const teachers = [];
    let deleteTeachers = false;
    this.selectedTeachers.map( t => teachers.push(+t.id));
    if (teachers.length === 0) {
      deleteTeachers = true;
    }
    this.classService.editClass({
      class_name: this.program_name.nativeElement.value,
      delete_teachers: deleteTeachers,
      class_description: this.description.nativeElement.value,
      schedule: this.changeDateFormaInSchedule(),
      repeat_time: this.repeat_time == 'false' || this.repeat_time == 'none' ? 'none' : 'week',
      teachers: teachers,
      program_id: ProgramCreateComponent.program.id,
      class_id: ProgramCreateComponent.editedItem.id,
      unique_schedule: !this.unique_schedule,
      replaced_schedule: this.unique_schedule === false ? ProgramCreateComponent.editedItem.selectedSchedule && ProgramCreateComponent.editedItem.selectedSchedule.replaced_schedule ? ProgramCreateComponent.editedItem.selectedSchedule.replaced_schedule : ProgramCreateComponent.editedItem.selectedSchedule ? ProgramCreateComponent.editedItem.selectedSchedule.id : null : null
    }).subscribe(
        (resp: {data: {classes: Class[], schedules: Schedule[], replaced_schedules: Schedule[]}}) => {
          ProgramCreateComponent.program.schedule = resp.data.schedules;
          ProgramCreateComponent.program.replaced_schedule = resp.data.replaced_schedules;
          ProgramCreateComponent.program.classes = resp.data.classes;
          ProgramScheduleComponent.classesByDates = {};
          this.programStore.dispatch(new UpdateProgram(ProgramCreateComponent.program));
          if (ProgramCreateComponent.dialogRef) {
            ProgramCreateComponent.dialogRef.close();
          }

        }
    );
  }
  changeDateFormaInSchedule() {
    let schedule = {};
  if(Object.keys(this.schedule).length>0){
    console.log(this.schedule, 'this.schedule');
    Object.keys(this.schedule).map( month => {
      Object.keys(this.schedule[month]).map( (day) => {
        let newSchedules = [];
        const t = ProgramCreateComponent.selectedDate;
        let date = moment().month(+month - 1).date(+day).format('YYYY-MM-DD');
        this.schedule[month][day].map( item => {

          if (item.api === false) {
            // if (!item.deleted) {
            //   item.id = null;
            // }
            let momentSch = moment(date, 'YYYY-MM-DD');
            // let momentSch = ProgramCreateComponent && ProgramCreateComponent.selectedDate && ProgramCreateComponent.selectedDate.isValid() ? moment(ProgramCreateComponent.selectedDate) : moment(date, 'YYYY-MM-DD');
            if (this.unique_schedule === false) {
              item.canceled = item.deleted;
              const dayNumberSelectedSchedule = this.getWeekDayNumberByDayName(ProgramCreateComponent.editedItem.selectedSchedule.dayName);
              const dayNumberCurrentSchedule = this.getWeekDayNumberByDayName(item.dayName);
              momentSch = momentSch.add(dayNumberCurrentSchedule - dayNumberSelectedSchedule, 'day' );
            }
            date = momentSch.format('YYYY-MM-DD');
            if (item.start === item.end) {
              item.end = moment(item.end, 'hh:mm A').add(1, 'hour').format('hh:mm A');
            }
            newSchedules.push(item);
          }
        });
        if (!schedule[date]) {
          schedule[date] = {};
        }
        if (Array.isArray(schedule[date])) {
          schedule[date] = [...schedule[date], ...newSchedules];
        } else {
          schedule[date] = newSchedules;
        }
      });
    });
    }
    else{
let selected_day='';
    this.selectedDays.map(day=>{
    let time=[];
 this.timeSlots.map( (item, index) => {

    if(item.dayName){
    if(index==0){
    let time  = this.getDayfromDayWeek(item.dayName);
     selected_day= moment([this.currentYear,this.currentMonth-1,time]).format('YYYY-MM-DD');
    }

    }
   else{
   if(index==0){
   console.log(this.currentMonth);
     selected_day= moment([this.currentYear,this.currentMonth-1,this.selectedDays[0]]).format('YYYY-MM-DD');
    }
   }
   time.push({
            start: item.get('time_start').value,
            end: item.get('time_end').value});
    });
    schedule[selected_day]=time;
   });

  }
    return schedule;
  }
  onSaveTimeSlot() {
    let times = [];
    this.editableInputs = [];
    this.timeSlots.map( (item, index) => {
      // const start = moment(item.get('time_start').value, 'HH:mm A').format('HH:mm A');
      // const end = moment(item.get('time_end').value, 'HH:mm A').format('HH:mm A');
      if (!item.get('api').value) {
        let found = false;
        times.map( (itemTime, iTime,) => {
          if (itemTime.index === item.index) {
            times[iTime] = item;
            found = true;
          }
        });
        if (found === false && item.get('time_start').value && item.get('time_end').value) {

          times.push({
            start: item.get('time_start').value,
            end: item.get('time_end').value,
            index: item.get('index').value,
            api: false,
            deleted: item.get('deleted').value ? true : false,
            canceled: item.get('canceled').value ? true : false,
            repeat_time: this.repeatEnable,
            year: this.currentYear,
            id: item.get('id').value,
            class_id: item.get('class_id').value,
            class_name: item.get('class_name').value,
            dayName: item.get('dayName').value,
          });
        }
      }
      // if (item.deleted === true && !item.id) {
      //   this.timeSlots.splice(index,1);
      // }
    });

    this.selectedDays.map( (item, index) => {
      if (times.length > 0) {
        this.errors['timeSlot'] = false;

        this.selectingTime.next({item: item, add: true});
        this.setSchedule(times, index);
      } else {
        this.selectingTime.next({item: item, add: false});

        if (this.schedule[this.currentMonth] && this.schedule[this.currentMonth][this.selectedDays[index]]) {
          delete this.schedule[this.currentMonth][this.selectedDays[index]];
        }
      }
    });
  }
  onChangingTime(event, index,  timeSlot, startTime = false) {

    if (event) {
      if (startTime === true) {
        timeSlot.index = index;
        timeSlot.get('time_start').setValue(event);
      } else {
        timeSlot.index = index;
        timeSlot.get('time_end').setValue(event);
      }
      timeSlot.get('time_start').markAsDirty();
      timeSlot.get('time_end').markAsDirty();

      if (timeSlot.valid) {
        if (moment(timeSlot.get('time_start').value, 'hh:mm A').isAfter(moment(timeSlot.get('time_end').value, 'hh:mm A'))) {
          timeSlot.get('time_end').setValue(moment(timeSlot.get('time_start').value, 'hh:mm A').format('hh:mm A'));
        }
        // this.finishEdit();
      }
    }
  }
  // wrongTime(times) {
  //   return !times || (!times[0] || !times[1] || times[1].toString() === times[0].toString())
  // }
  onSelectedDay(value) {

    if (value) {
      if (!value.cntr) {
        this.selectedDays = [];
      }
      if (value.initDayName) {
        this.initDayName = value.dayName;
      } else {
        this.initDayName = null;
      }
      if (!this.selectedDays.includes(value.day)) {
        this.selectedDays.push(value.day);

        this.timeSlots = [];
        let schedules = [];
        if (this.repeatEnable === true ) {
          if (!value.dayName) {

            value.dayName = this.getWeekDayNameByNumber(moment().date(value.day).month(value.month - 1).isoWeekday());
          }

          if (this.reorganizedScheduleByWeekName[value.dayName]) {
            schedules =  this.reorganizedScheduleByWeekName[value.dayName];
          }
        } else {
          schedules = this.schedule[value.month] && this.schedule[value.month][value.day] ? this.schedule[value.month][value.day] : [];
        }

        if (schedules.length > 0) {
          schedules.map(item => {

            if ((!item.deleted || item.deleted === false) && (!item.canceled || item.canceled === false)) {
              item.saved = true;
              this.onAddTimeSlot(item);
            }
          });
        } else {
          this.onAddTimeSlot({start: null, end: null, api: null, class_name: null, id: null,
            dayName: value.dayName, class_id: null, index: null, saved: false});
        }
      }
    }
  }
  onMonthToRight() {
    this.currentMonth -= 1;

    if (this.currentMonth < 1) {
      this.currentYear--;
      this.currentMonth = 12;
    }
    this.selectedDays = [];
    this.monthsNumber.next({month: this.currentMonth, year: this.currentYear});
    this.moveMonthsCarousel.next('right');
  }
  onMonthToLeft() {
    this.currentMonth += 1;

    if (this.currentMonth > 12) {
      this.currentYear++;
      this.currentMonth = 1;
    }
    this.selectedDays = [];
    this.monthsNumber.next({month: this.currentMonth, year: this.currentYear});
    this.moveMonthsCarousel.next('left');
  }
  // onSelectedRepeaTime(event) {
  //   this.repeat_time = event.value;
  // }
  setSchedule(time, index) {
    const day = this.selectedDays[index];
    // this.schedule = {};
    if (!this.schedule[this.currentMonth]) {
      this.schedule[this.currentMonth] = {};
    }

    time.map( item => {
      // item.dayName = moment().month(this.currentMonth - 1).date(day).format('dddd').substring(0, 3).toLowerCase();

      // if (!this.schedule[this.currentMonth][day]) {
      //   this.schedule[this.currentMonth][day] = [];
      // }
      // if (item.deleted !== true) {
      //   this.schedule[this.currentMonth][day].push(item);
      // }
      if (item.id) {
        Object.keys(this.schedule).map(month => {
          Object.keys(this.schedule[month]).map( dayWeek => {
            Object.keys(this.schedule[month][dayWeek]).map(schedule => {
              if (this.schedule[month][dayWeek][schedule].id === item.id) {
                this.schedule[month][dayWeek][schedule].start = item.start;
                this.schedule[month][dayWeek][schedule].end = item.end;
                this.schedule[month][dayWeek][schedule].api = false;
                this.schedule[month][dayWeek][schedule].deleted = item.deleted;
                this.schedule[month][dayWeek][schedule].canceled = item.canceled;
                this.schedule[month][dayWeek][schedule].repeat_time = item.repeat_time;
                this.schedule[month][dayWeek][schedule].year = item.year;
                this.schedule[month][dayWeek][schedule].class_name = item.class_name;
              }
            });
          });
        });
      } else {
        item.dayName = moment().month(this.currentMonth - 1).date(day).format('dddd').substring(0, 3).toLowerCase();

        if (!this.schedule[this.currentMonth][day]) {
          this.schedule[this.currentMonth][day] = [];
        }
        // if (item.deleted !== true) {
        //   this.schedule[this.currentMonth][day].push(item);
        // }
        let found = false;
        this.schedule[this.currentMonth][day].map((sch, i) => {

          if (sch.index === item.index) {
            found = true;
            this.schedule[this.currentMonth][day][i] = item;
            // if (item.deleted === true) {
            //   this.schedule[this.currentMonth][day].splice(i, 1);
            // }
          }
        });
        if (found === false && item.deleted !== true) {

          this.schedule[this.currentMonth][day].push(item);
        }
      }
    });
    this.insertingSchedule.next(this.schedule);

    this.reorganizeScheduleByWeekDay();
  }
  onAddTimeSlot(time: {start: string, end: string, api: string, class_name: string, id: number, dayName: string, class_id: number, index: string, saved: boolean}
                    = {start: null, end: null, api: null, class_name: null, id: null, dayName: null, class_id: null, index: null, saved: false}) {
    const fullDate = new Date();
    // const d = moment(fullDate).format('L');
    if (this.timeSlots.length < 5) {
      this.setTimeStart.next({hours: this.getHours(time.start) + '', minutes: this.getMinutes(time.start) + '', index: time.index});
      this.setTimeEnd.next({hours: this.getHours(time.end) + '', minutes: this.getMinutes(time.end) + '', index: time.index});
      this.timeSlots.push(this.fb.group({
        'time_start': new FormControl(
            time.start ? time.start : null),
        'time_end': new FormControl(
            time.end ? time.end : null),
        'api': time.api ? time.api : false,
        'dayName': time.dayName,
        'deleted': false,
        'canceled': false,
        'index':  time.index ? time.index :this.timeSlots.length,
        'class_name': time.class_name ? time.class_name : null,
        'class_id': time.class_id ? time.class_id : null,
        'saved': time.saved,
        'id': time.id ? time.id : null
      }));
    }

  }
  onDeleteTimeSlot(index) {
    this.openConfirmPopup(index);
    // if (ProgramCreateComponent.editedItem && ProgramCreateComponent.editedItem.selectedSchedule &&
    //   ProgramCreateComponent.editedItem.selectedSchedule.replaced_schedule ||
    // this.repeatEnable === false) {
    //   this.openConfirmPopup(index);
    // } else {
    //   this.openConfirmPopup(index, true);
    // }
  }
  actionDelete(index: number, canceled: boolean) {

    if (!canceled) {
      this.timeSlots[index].get('deleted').setValue(true);

    } else {
      this.timeSlots[index].get('canceled').setValue(true);
      this.unique_schedule = false;
    }
    this.finishEdit();
  }
  openConfirmPopup(index, repeatEnable = false) {
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.repeatable = repeatEnable;
    ConfirmModalComponent.methodDelete = 'actionDelete';
    ConfirmModalComponent.methodDeleteAll = 'actionDelete';
    ConfirmModalComponent.textModal = 'Delete?';
    ConfirmModalComponent.textButton = 'Delete';
    ConfirmModalComponent.methodDeleteParam = index;
    ConfirmModalComponent.methodDeleteAllParam = true;
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
    this.confirmDialog.afterClosed().subscribe(result => {
      this.confirmDialog.close();
    });
  }
  toFormat(time) {
    return moment(time).format('hh:mm A');
  }
  getHours(time) {
    if (time && time.length > 0) return  moment(time, 'hh:mm').format('hh');
    return '';
  }
  getTimePart(time) {
    if (time && time.length > 0) return  moment(time, 'hh:mm A').format('A');
    return 'AM';
  }
  getMinutes(time) {
    if (time && time.length > 0) return  moment(time, 'hh:mm').format('mm');
    return '';
  }
  checkErrors() {
    let formatedSchedule = this.changeDateFormaInSchedule();
    let result = true;
    if (this.selectedDays.length === 0) {
      return false;
    }
    // this.selectedDays.map( day => {
    //   let date = moment().month(moment().month()).date(+day).format('YYYY-MM-DD');
    //   if (!formatedSchedule[date] || formatedSchedule[date].length === 0) {
    //     result = false;
    //   }
    // });
    if (!result) {
      this.errors['timeSlot'] = 'Please Add Time Slot!';
      return result;
    }
    if (!this.program_name.nativeElement.value || this.program_name.nativeElement.value.length < 0) {
      this.errors['name'] = 'This field is required!';
      return false;
    }
    return true;
  }
  toggleRepeat() {
    this.repeatEnable = !this.repeatEnable;
    this.selectedDays = [];
    this.reorganizedScheduleByWeekName = [];
    this.schedule = [];
    this.insertingSchedule.next([]);
  }
  selectWeekDay(event) {
    const li = event.target.closest('li');
    if (li) {
      const day = li.innerText.toLowerCase();

      let value: {day: number, month: number, cntr: boolean, dayName: string} = {day: null, month: null, cntr: null, dayName: null};
      value.day = this.getDayfromDayWeek(day);
      value.dayName = day;
      value.month = this.currentMonth;
      value.cntr = event.ctrlKey || event.metaKey;
      if (this.dayWeekIsSelected(day, true) === false) {
        this.onSelectedDay(value);
      } else {
        for (let i = 0; i < this.selectedDays.length; i++) {
          if (this.selectedDays[i] === value.day) {
            this.selectedDays.splice(i, 1);
            break;
          }
        }
      }
    }
  }
  dayWeekIsSelected(day: string, deleteIfFound = false) {
    let found = false;
    if (!this.initDayName) {
      const dayFound = this.getDayfromDayWeek(day.toLowerCase());
      this.selectedDays.map((selectedDay, i) => {
        if (dayFound === selectedDay) {

          found = true;
          // if (deleteIfFound === true) {
          //   this.selectedDays.splice(i, 1);
          //   if (this.schedule[this.currentMonth] && this.schedule[this.currentMonth][dayFound]) {
          //     delete this.schedule[this.currentMonth][dayFound];
          //     delete this.reorganizedScheduleByWeekName[day];
          //   }

          // }
        }
      });
    } else if (this.initDayName === day.toLowerCase()) {
      found = true;
    }
    return found;
  }
  dayWeekIsWithTime(day: string) {
    return this.reorganizedScheduleByWeekName[day.toLowerCase()];
  }
  getDayfromDayWeek(day: string) {
    const dayNumber = this.getWeekDayNumberByDayName(day);
    const month = moment().month(this.currentMonth - 1).startOf('month');

    let date = 0;
    for ( let i = 0; i <= 10; i++) {
      const testMonth = month.clone();
      const dayMonth = testMonth.add(i, 'day');
      const t = dayMonth.isoWeekday();
      if ( dayMonth.isoWeekday() === dayNumber) {

        date = dayMonth.date();
        break;
      }
    }
    return date;
  }
  getWeekDayNumberByDayName(day) {
    let dayNumber = 7;

    switch (day) {
      case 'mon':
        dayNumber = 1;
        break;
      case 'tue':
        dayNumber = 2;
        break;
      case 'wed':
        dayNumber = 3;
        break;
      case 'thu':
        dayNumber = 4;
        break;
      case 'fri':
        dayNumber = 5;
        break;
      case 'sat':
        dayNumber = 6;
        break;
    }
    return dayNumber;
  }
  getWeekDayNameByNumber(dayNumber) {
    let day = 'sun';

    switch (dayNumber) {
      case 1:
        day = 'mon';
        break;
      case 2:
        day = 'tue';
        break;
      case 3:
        day = 'wed';
        break;
      case 4:
        day = 'thu';
        break;
      case 5:
        day = 'fri';
        break;
      case 6:
        day = 'sat';
        break;
    }
    return day;
  }
  reorganizeScheduleByWeekDay() {
    this.reorganizedScheduleByWeekName = [];
    Object.keys(this.schedule).map(monthNumber => {
      Object.keys(this.schedule[monthNumber]).map( dayNumber => {
        this.schedule[monthNumber][dayNumber].map( schedule => {

          if ((!schedule.deleted || schedule.deleted === false) && (!schedule.canceled || schedule.canceled === false)) {
            const dayName = moment().month(+monthNumber - 1).date(+dayNumber).format('dddd').substring(0, 3).toLowerCase();
            schedule.dayName = dayName;
            if (!this.reorganizedScheduleByWeekName[dayName]) {
              this.reorganizedScheduleByWeekName[dayName] = [];
            }
            this.reorganizedScheduleByWeekName[dayName].push(schedule);
          }
        });
      });
    });

  }
  finishEdit() {

    this.tmpName = this.program_name.nativeElement.value;
    this.tmpDescription = this.description.nativeElement.value;
    this.tmpSchedule = this.schedule;
    this.tmpMultipleSelectedTeacher = this.selectedTeachers;
    this.onSaveTimeSlot();
    // ProgramCreateComponent.sourceSchedule = this.schedule;
    this.editableInputs = [];
    const days = this.selectedDays;
    this.selectedDays = [];
    days.map( dayS => {
      this.onSelectedDay({day: dayS, cntr: days.length > 1, month: this.currentMonth});
    });
  }
  cancelEdit() {
    this.program_name.nativeElement.value = this.tmpName;
    this.description.nativeElement.value = this.tmpDescription;
    this.schedule = this.tmpSchedule;
    this.selectedTeachers = this.tmpMultipleSelectedTeacher;

    // if (this.repeatEnable === true) {
    //   this.reorganizeScheduleByWeekDay();
    // }
    // this.timeSlots = [];
    this.editableInputs = [];
    if (this.sourceName === ProgramCreateComponent.source_class_edit) {
      const schedul = ProgramCreateComponent.editedItem.selectedSchedule as Schedule;
      this.onSelectedDay({day: +schedul.day, cntr: false, month: schedul.month});
    } else {
      const days = this.selectedDays;
      this.selectedDays = [];
      days.map( dayS => {
        this.onSelectedDay({day: dayS, cntr: days.length > 1, month: this.currentMonth});
      });
    }

    this.insertingSchedule.next(this.schedule);

  }
  isPrgramEdit() {
    return this.sourceName === ProgramCreateComponent.source_program_edit;
  }
  isForClass() {
    return this.sourceName === ProgramCreateComponent.source_class_edit || this.sourceName === ProgramCreateComponent.source_class;
  }
  onClosePopup(event) {
    this.closeProgramModal(event);
    // this.programStore.dispatch(new ClosePopup());
  }
  closeProgramModal(event?) {
    if (event) {
      event.stopPropagation();
    }
    if (ProgramCreateComponent.dialogRef) {
      ProgramCreateComponent.dialogRef.close();
    }
  }
  closeAction() {
    this.closeProgramModal();
  }
  onOpenInviteTeacher() {
    StudentCreateComponent.source = 'add_teacher';
    this.dialogRefCreateModal = this.dialog.open(StudentCreateComponent);
    StudentCreateComponent.modalRef = this.dialogRefCreateModal;
    StudentCreateComponent.fromScratch = this.sourceName === 'program';
    this.dialogRefCreateModal.afterClosed().subscribe(result => {
      this.dialogRefCreateModal.close();
    });
  }
  findStoredTimeSlot() {
    let found = false;
    Object.keys(this.schedule).map(month => {
      Object.keys(this.schedule[month]).map(day => {
        this.schedule[month][day].map(sch => {
          if (sch.deleted === false) {
            found = true;
          }
        });
      });
    });

    return found;
  }
  getMultipleTeachersList() {
    let teachersList = '';
    this.selectedTeachers.map( (t, i) => {
      teachersList += t.itemName;
      if (i < this.selectedTeachers.length - 1) {
        teachersList += ', ';
      }
    });
    return teachersList;
  }
  getAllTeachers() {
    this.teacherService.getAll()
        .subscribe(
            (resp: { data: User[] }) => {
              this.teacherStore.dispatch(new SetTeachers(resp.data));
            }
        );
  }
}
